<div class="md-form form-inline form-group">
  <mat-form-field class="rule-type-input">
    <mat-label>Transform</mat-label>
    <mat-select (selectionChange)="selectTransform($event)" [value]="selected" placeholder="Select">
      <mat-option *ngFor="let transform of transforms" [value]="transform">{{transform.name}}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
